import {all, fork, put, select, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import OpeningActions from '../Opening/actions';
import {TableName} from "./options";
import { L } from '../List/reducer';
import { readLists } from 'bukku/redux/Transaction/initTransaction/helper/readLists';

function patternFn(name, type) {
    return action => action.type === type && action.name === name;
}

// Opening Item: Recalculate Totals
function* calculateOpeningTotal() {
    yield takeEvery(
        patternFn(TableName.opening_balance, actions.SET_ITEM),
        function* () {
            const opening_items = yield select(state => state.Editable[TableName.opening_balance].items);
            yield put({
                type: OpeningActions.OPENING_CALCULATE_TOTAL,
                opening_items,
            });
        });
}

// Batch Transaction: Read Custom Fields
function* readBatchCustomFields() {
    yield takeEvery(
        // on batch tables init, fetch custom fields from redux store
        // to be used in reducer
        [
            patternFn(TableName.batch_sale_order, actions.SET_FORM_REF),
            patternFn(TableName.batch_invoice, actions.SET_FORM_REF),
            patternFn(TableName.batch_invoice_cash, actions.SET_FORM_REF),
            patternFn(TableName.batch_bank_income, actions.SET_FORM_REF),
            patternFn(TableName.batch_bank_expense, actions.SET_FORM_REF),
        ],
        function* (action) {
            yield readLists([L.fields], {}, true, true);
            const fields = yield select(state => state.List.fields);
            yield put({
                type: actions.ADD_BATCH_CUSTOM_FIELDS,
                tableName: action.name,
                fields,
            });
        });
}

export default function* rootSaga() {
    yield all([
        fork(calculateOpeningTotal),
        fork(readBatchCustomFields),
    ]);
}
